import React, { useEffect } from "react";
import { pipe } from "fp-ts/lib/function";
import { option } from "fp-ts";
import { TContainerStateProps } from "../../state/TContainerStateProps";
import { CRMCaseTimelineCard } from "../../components/CRMCaseTimeline/CRMCaseTimelineCard";
import { TCaseTimelineRoadblockContext } from "../../../../domain/codecs/form/CaseTimelineForm";
import { createChangeRouteAction } from "../../state/router/createChangeRouteAction";
import { updateRouteWithBlockChange } from "../../state/router/updateRouteWithBlockChange";

export const CRMCaseTimelineCardContainer = (props: TContainerStateProps): JSX.Element => {

    useEffect(
        () => {
            props.dispatch({
                type: "LEGAL_CASE_GET_TIMELINE",
                payload: null,
            });
        },
        []
    );

    const onOpenRoadblock = (roadblock: TCaseTimelineRoadblockContext) => pipe(
        props.state.routes,
        updateRouteWithBlockChange(
            "case_roadblocks",
            2,
            (block) => ({ ...block, meta: { openRoadblockID: roadblock.roadblock_id, openRoadblockView: "chat" } })
        ),
        option.fold(
            () => props.dispatch(createChangeRouteAction(
                "VIEW_CRM_LEGAL_CASE",
                { caseId: props.state.forms.case_timeline_block.edited.case_id },
                { visible_tab: "details" },
                [
                    { type: "case_details", meta: {} },
                    { type: "case_overview", meta: {} },
                    { type: "case_roadblocks", meta: { openRoadblockID: roadblock.roadblock_id, openRoadblockView: "chat" } },
                ],
            )),
            (action) => props.dispatch(action),
        ),
    );

    return (
        <CRMCaseTimelineCard
            form={props.state.forms.case_timeline_block}
            onTypeMessage={(form) => props.dispatch({
                type: "LEGAL_CASE_TIMELINE_TYPE_MESSAGE",
                payload: form,
            })}
            onSubmitMessage={(form) => props.dispatch({
                type: "LEGAL_CASE_TIMELINE_SUBMIT_MESSAGE",
                payload: form,
            })}
            onSelectRoadblock={(target) => props.dispatch({
                type: "LEGAL_CASE_TIMELINE_SELECT_ROADBLOCK",
                payload: target,
            })}
            onOpenRoadblock={onOpenRoadblock}
            onEditNote={(payload) => props.dispatch({
                type: "LEGAL_CASE_TIMELINE_EDIT_NOTE",
                payload,
            })}
            onPinNote={(payload) => props.dispatch({
                type: "LEGAL_CASE_TIMELINE_PIN_NOTE",
                payload,
            })}
        />
    );
};
